export type AppLang = 'sr' | 'en'

/**
 * Default language for a given host:
 *  - *.rs  -> Serbian
 *  - *.com -> English
 *  - anything else (localhost, IPs, dev) -> Serbian
 */
export function defaultLangForHost(hostname: string): AppLang {
  const host = (hostname || '').toLowerCase()
  if (host.endsWith('.com')) return 'en'
  if (host.endsWith('.rs')) return 'sr'
  return 'sr'
}

/**
 * Resolves the language to use on app start.
 * An explicit user choice (saved in localStorage) always wins; otherwise
 * fall back to the domain-based default.
 */
export function resolveInitialLang(): AppLang {
  const stored = localStorage.getItem('lang')
  if (stored === 'sr' || stored === 'en') return stored
  return defaultLangForHost(window.location.hostname)
}
